export default __webpack_public_path__ + "static/media/onePieceLogo.6519eb4b.png";